import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'
import { env } from './env'

/**
 * Browser client. Uses the public anon key: it identifies the project, it does
 * not authorize anything. Authorization = RLS + SECURITY DEFINER functions.
 * Every request carries a correlation id so database audit rows and client
 * errors can be matched.
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
  global: {
    fetch: (input, init) => {
      const headers = new Headers(init?.headers)
      if (!headers.has('x-correlation-id')) headers.set('x-correlation-id', crypto.randomUUID())
      return fetch(input, { ...init, headers })
    },
  },
})

export function publicMediaUrl(path: string | null | undefined, opts?: { width?: number }): string | null {
  if (!path) return null
  if (/^https?:\/\//.test(path)) return path
  const { data } = supabase.storage.from('media').getPublicUrl(path)
  void opts
  return data.publicUrl
}
